export function resolveThreadUserName(...candidates) {
    for (const candidate of candidates) {
        if (!candidate) continue;
        if (typeof candidate === "string" && candidate.trim()) return candidate.trim();
        if (candidate.name) return candidate.name;
    }
    return "";
}

export function resolveThreadUser(...candidates) {
    for (const candidate of candidates) {
        if (!candidate) continue;
        if (typeof candidate === "object" && candidate.name) return candidate;
        if (typeof candidate === "string" && candidate.trim()) {
            return {name: candidate.trim()};
        }
    }
    return null;
}

export function resolveWorkAuthor(entry) {
    if (!entry) return "";
    return resolveThreadUserName(
        entry.inProgressCloseUser,
        entry.inProgressUser,
        entry.inProgressCloseUserName,
        entry.inProgressUserName,
        entry.closeUser,
        entry.closeUserName,
    );
}

export function resolveWorkUser(entry) {
    if (!entry) return null;
    return resolveThreadUser(
        entry.inProgressCloseUser,
        entry.inProgressUser,
        entry.inProgressCloseUserName,
        entry.inProgressUserName,
        entry.closeUser,
        entry.closeUserName,
    );
}

export function resolveRequestAuthor(entry) {
    if (!entry) return "";
    return resolveThreadUserName(
        entry.requestUser,
        entry.requestCloseUser,
        entry.verificationCloseUser,
        entry.verifiedUser,
        entry.requestUserName,
        entry.verificationCloseUserName,
        entry.requestCloseUserName,
    );
}

export function resolveRequestUser(entry) {
    if (!entry) return null;
    return resolveThreadUser(
        entry.requestUser,
        entry.requestCloseUser,
        entry.verificationCloseUser,
        entry.verifiedUser,
        entry.requestUserName,
        entry.verificationCloseUserName,
        entry.requestCloseUserName,
    );
}

/**
 * rework 이력 1건 = 작업 완료 + 검수(재작업) 결과가 묶여 있을 수 있음 → 피드 항목으로 분리
 */
export function parseReworkCycleActivities(entry, context = {}) {
    if (!entry) return [];

    const inspectorFallback = resolveThreadUser(context.inspector);
    const inspectorNameFallback = resolveThreadUserName(context.inspector);

    const activities = [];
    const workText = entry.inProgressDescription?.trim();

    if (workText) {
        activities.push({
            type: "work",
            user: resolveWorkUser(entry),
            name: resolveWorkAuthor(entry),
            action: "작업을 완료했습니다",
            time: entry.inProgressCloseDate || undefined,
            body: workText,
        });
    }

    const requestText = entry.requestDescription?.trim();
    const verifyText = entry.verificationDescription?.trim();
    const hasDeadlineChange = Boolean(entry.beforeEndDate || entry.afterEndDate);

    if (requestText) {
        activities.push({
            type: "verification",
            user: resolveRequestUser(entry) || inspectorFallback,
            name: resolveRequestAuthor(entry) || inspectorNameFallback,
            action: "검수 결과",
            time: entry.requestCloseDate || entry.verificationCloseDate || undefined,
            body: requestText,
            deadlineChange: hasDeadlineChange
                ? {before: entry.beforeEndDate, after: entry.afterEndDate}
                : null,
        });
        return activities;
    }

    const hasVerification = Boolean(
        verifyText
        || entry.requestCloseDate
        || entry.verificationCloseDate
        || hasDeadlineChange,
    );

    if (!hasVerification) {
        return activities;
    }

    let action = "검수 결과";
    let body = verifyText || "";

    if (verifyText) {
        action = "검수를 완료했습니다";
        body = verifyText;
    } else if (hasDeadlineChange) {
        action = "마감일을 변경했습니다";
        body = `${entry.beforeEndDate || "-"} → ${entry.afterEndDate || "-"}`;
    }

    activities.push({
        type: "verification",
        user: resolveRequestUser(entry) || inspectorFallback,
        name: resolveRequestAuthor(entry) || inspectorNameFallback,
        action,
        time: entry.requestCloseDate || entry.verificationCloseDate || undefined,
        body,
        deadlineChange: null,
    });

    return activities;
}
